const PARTNER_SKIP_PATHS = ['/partners', '/auth'];

const shouldSkipHydration = (url: string): boolean =>
    PARTNER_SKIP_PATHS.some((path) => url.startsWith(path));

export default shouldSkipHydration;
